import { useTranslation } from 'react-i18next';

import styles from './Filter.module.scss';
import { FC } from 'react';
import {
  ExternalUserDto,
  ExternalUserDtoCustomerDto,
  PartnerConnectionPreviewDto,
} from '../../types/api';
import { Chip, Stack } from '@mui/material';

interface IPartnerImageProps {
  name: string;
}

const PartnerImage: FC<IPartnerImageProps> = ({ name }) => {
  try {
    const image = require(`../../assets/partners/${name}.png`);
    if (!image) return null;

    return <img src={image} title={name} alt={name} />;
  } catch (error) {
    return null;
  }
};

function getPartnerConnectionName(partnerConnection: PartnerConnectionPreviewDto): string {
  let name = partnerConnection.partnerCode || 'Unknown Partner';
  if (partnerConnection.name) {
    name += ` (${partnerConnection.name})`;
  }
  return name;
}

interface IFilterProps {
  customerId: string;
  currentUser: ExternalUserDto;
  partnerConnection: PartnerConnectionPreviewDto;
  changePartnerConnection?: (item: PartnerConnectionPreviewDto) => void;
}

const Filter: FC<IFilterProps> = ({
  changePartnerConnection,
  currentUser,
  partnerConnection,
  customerId,
}) => {
  const { t } = useTranslation();

  const partnerConnections = currentUser?.customers?.find(
    (c: ExternalUserDtoCustomerDto) => c?.id === customerId
  )?.partnerConnections;

  const handlePartnerChange = (partnerConnectionId: string): void => {
    console.log(partnerConnectionId)
    const selectedPartnerConnection = partnerConnections?.find(
      (p: PartnerConnectionPreviewDto) => p.id === partnerConnectionId
    );

    if (changePartnerConnection && selectedPartnerConnection) {
      changePartnerConnection(selectedPartnerConnection);
    }
  };

  return (
    <div className={styles['filter-wrapper']}>
      <div className={styles.partners}>
        <label>{t('overview-filter-partner')}</label>
        <Stack direction="row" ml={1} flexWrap="wrap" rowGap={1}>
          {partnerConnections?.map(
            (p, index: number) => (
              <Chip
                key={`${p.id}`}
                label={getPartnerConnectionName(p)}
                color={p.partnerCode === partnerConnection.partnerCode ? 'primary' : 'default'}
                onClick={() => handlePartnerChange(p.id!)}
                size="small"
                sx={{ mr: 1 }}
              />
            )
          )}
        </Stack>
      </div>
      <div className={styles.client}>
        {partnerConnection && <PartnerImage name={partnerConnection.partnerCode ?? ''} />}
      </div>
    </div>
  );
};

export default Filter;
